export type SeoMeta = {
  title: string;
  description: string;
  keywords?: string;
  developer?: string;
  robots?: string;
  googlebot?: string;
};

const defaultSeo: SeoMeta = {
  title: "CodeRiite | Computational Thinking for Kids",
  description: "Computational Thinking: Unlock Creativity with CodeRiite | Mumbai",
  keywords:
    "CodeRiite, coding classes, computational thinking, creativity, Mumbai, programming for kids, coding for beginners, coding workshops, coding bootcamps",
  developer: "CodeAngle Technologies Pvt Ltd",
};

const seoByPath: Record<string, SeoMeta> = {
  "/": defaultSeo,
  "/about": {
    title: "About CodeRiite | Computational Thinking for Kids",
    description: "Learn about CodeRiite and our mission to build computational thinking in young learners.",
  },
  "/gallery": {
    title: "Gallery | CodeRiite",
    description: "Explore moments from our screen-free coding sessions and hands-on learning experiences.",
    robots: "noindex, nofollow",
    googlebot: "noindex, nofollow",
  },
  "/courses": {
    title: "Courses | CodeRiite",
    description: "Discover coding and computational thinking courses for kids across multiple learning paths.",
  },
  "/contact": {
    title: "Inquiry | CodeRiite",
    description: "Contact CodeRiite to learn more about classes, schedules, and enrollment options.",
  },
  "/courses/screen-free": {
    title: "Screen-Free Coding | CodeRiite",
    description: "Hands-on, unplugged coding activities that build logic and problem-solving skills.",
  },
  "/courses/online": {
    title: "Online Program | CodeRiite",
    description: "Live online coding classes that build computational thinking and creativity.",
  },
  "/courses/scratch": {
    title: "Scratch Programming | CodeRiite",
    description: "Create interactive stories and games with Scratch while learning coding fundamentals.",
  },
  "/courses/bot-programming": {
    title: "Bot Programming | CodeRiite",
    description: "Program robots and build real-world automation skills through engaging projects.",
  },
  "/courses/home-coaching": {
    title: "Home & Online Coaching | CodeRiite",
    description: "Personalized coaching at home or online for focused coding growth.",
  },
};

const normalizePath = (pathname: string) => {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
};

export const getSeoForPath = (pathname: string) => {
  const normalized = normalizePath(pathname);
  const match = seoByPath[normalized];
  return match ? { ...defaultSeo, ...match } : defaultSeo;
};
